import { createContext, useContext, useMemo, useState } from 'react'
import { CheckAnimationIcon } from '@nv/images/design/check-animation-icon'
import { XCircleAnimatedIcon } from '@nv/images/design/x-circle-animated-icon'

export const NVAlertsContext = createContext()

const defaultAlertState = {
  isOpen: false,
  type: 'success',
  message: 'NV Alert... something went wrong oops',
  style: { backgroundColor: 'var(--green-100)' },
  icon: <CheckAnimationIcon />,
  children: null,
}

const defaultStyles = {
  success: { backgroundColor: 'var(--green-100)' },
  error: { backgroundColor: 'var(--red-100)' },
  info: { backgroundColor: 'var(--warning-color)' },
}

export const NVAlertsProvider = ({ children, initialAlertState = defaultAlertState }) => {
  const [alert, setAlert] = useState(initialAlertState ?? defaultAlertState)

  const showAlert = ({ message, style = {}, children = null, type = 'success', icon = null }) => {
    const defaultIcons = {
      success: <CheckAnimationIcon />,
      error: <XCircleAnimatedIcon />,
      info: null,
    }

    setAlert({
      isOpen: true,
      type,
      message: message ?? defaultAlertState.message,
      style: { ...defaultStyles[type], ...style },
      icon: icon ?? defaultIcons[type],
      children,
    })
  }

  const hideAlert = () => setAlert(defaultAlertState)

  const value = useMemo(
    () => ({
      alert,
      setAlert,
      showAlert,
      hideAlert,
    }),
    [alert],
  )

  return <NVAlertsContext.Provider value={value}>{children}</NVAlertsContext.Provider>
}

export const useNVAlertsContext = () => useContext(NVAlertsContext)
